import { Paper, Typography, Box } from '@mui/material';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend,
} from 'recharts';

const CallsChart = ({ sources }) => {
  const sorted = sources
    .filter((s) => s.calls > 0)
    .sort((a, b) => b.calls - a.calls)
    .slice(0, 15)
    .map((s) => ({
      name: s.sourceName,
      answered: s.answeredCalls,
      missed: s.missedCalls,
      firstTime: s.firstTimeCalls,
    }));

  const chartHeight = Math.max(250, sorted.length * 48 + 60);

  return (
    <Paper sx={{ p: 2.5, mb: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 600, color: '#0d3c61' }}>Calls by Source</Typography>
      </Box>
      {sorted.length === 0 ? (
        <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
          No call data available
        </Typography>
      ) : (
        <ResponsiveContainer width="100%" height={chartHeight}>
          <BarChart data={sorted} layout="vertical" margin={{ left: 20, right: 20, top: 5, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" horizontal={false} />
            <XAxis type="number" fontSize={11} />
            <YAxis type="category" dataKey="name" width={140} fontSize={11} tick={{ fontWeight: 500 }} />
            <Tooltip contentStyle={{ fontSize: 12 }} />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            <Bar dataKey="answered" name="Answered" stackId="calls" fill="#43a047" radius={[0, 0, 0, 0]} barSize={24} />
            <Bar dataKey="missed" name="Missed" stackId="calls" fill="#e53935" radius={[0, 4, 4, 0]} barSize={24} />
            <Bar dataKey="firstTime" name="First-time" fill="#ff9800" radius={[0, 4, 4, 0]} barSize={24} />
          </BarChart>
        </ResponsiveContainer>
      )}
    </Paper>
  );
};

export default CallsChart;
